import React from 'react';
import { View, ScrollView, Text, Link, Confirm, TimeStamp, ASButton } from 'core';
import { IcoTrash, IconComputer, IcoPhone } from 'icons';
import { SESSIONS, style, theme } from 'constants';
import * as actions from 'actions';
import { lang } from 'lang';

const Devices = ({ devices }) => {
  const { sessions, current_session } = devices;

  return (
    <ScrollView>
      {sessions.map(session => {
        const Icon = session.app && session.app.includes('web') ? IconComputer : IcoPhone;
        const options = [{ icon: IcoTrash, text: lang.DELETE, onPress: () => Confirm(() => actions.sendRemoveSession(session.id)) }];
        return (
          <View key={session.id} style={styles.session_row}>
            <Icon style={styles.icon} />
            <View style={styles.session}>
              {session.online === true ? (
                <Text style={{ color: theme.success_color }}>{lang.ONLINE}</Text>
              ) : (
                <Text>
                  {lang.LAST_ACTIVITY}
                  <TimeStamp value={session.online} only_relative style={{ fontSize: theme.font_md, color: theme.gray_color }} />
                </Text>
              )}
              <Text style={{ color: theme.gray_color_lighten(0.6), paddingVertical: 5 }}>
                {session.city ? lang.CITY_SESSION(session) : session.ip}
              </Text>
              <Text style={{ color: theme.gray_color_lighten(0.6) }}>{session.device}</Text>
            </View>
            {session.id !== current_session ? <ASButton options={options} /> : null}
          </View>
        );
      })}
      <View style={styles.session}>
        <Link
          title={lang.LOGOUT_ALL_DEVICES}
          onPress={() => Confirm(() => actions.sendRemoveSession(SESSIONS.ALL))}
          style={{ alignSelf: 'center' }}
          selected
        />
      </View>
    </ScrollView>
  );
};

const styles = style({
  session_row: {
    flex: 1,
    borderBottomWidth: 1,
    borderColor: theme.gray_color_lighten(0.1),
    alignItems: 'center',
    flexDirection: 'row'
  },
  icon: {
    paddingHorizontal: 20
  },
  session: {
    flex: 1,
    minHeight: 100,
    paddingVertical: 20
  },
  section_devider: {
    backgroundColor: theme.gray_color_lighten(0.05),
    height: 50
  }
});

export default Devices;



// WEBPACK FOOTER //
// ./src/components/middle/settings/devices.js